export default {
    props: {
        bkErrors : {
            type: [Array, Object]
        }
    },

    data() {
        return {
            dirtyFields: {}
        }
    },

    computed: {
        isErrorVisible() {
            /**
             * @param {string} field
             * @return {boolean}
             */
            return (field) => {
                return (this.errors && this.errors.has(field)) || ( !this.dirtyFields[field] && Object.prototype.hasOwnProperty.call(this.bkErrors, field));
            }
        },

        getErrorMessage() {
            /**
             * @param {string} field
             * @return {string}
             */
            return (field) => {
                return (this.errors && this.errors.first(field)) || ( !this.dirtyFields[field] && this.bkErrors[field] && this.bkErrors[field][0]) || '';
            }
        }
    },

    methods: {
        /**
         *
         * @param {string} field
         */
        setDirty(field) {
            this.dirtyFields[field] = true;
        }
    }
}